<template>
  <!--用水报装-->
  <div class="page">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <van-tabs v-model="active" v-show="flag">
      <van-tab title="个人用户">
      </van-tab>
      <van-tab title="单位用户">
      </van-tab>
    </van-tabs>

    <van-form @submit="onUserSubmit" :validate-trigger="$trigger" v-show="active == 0">
      <van-cell-group title="申请信息">
        <van-field v-model="form.fareaid" required is-link readonly label="用水区域" placeholder="请选择所在区域" @click="fareaidShow = true" :rules="[{ required: true, message: '请选择所在区域'  }]" />
        <van-popup v-model="fareaidShow" round position="bottom">
          <van-cascader v-model="cascaderValue" title="请选择所在区域" :options="fareaidOptions" @close="fareaidShow = false" @change="onFareaidChange" @finish="onFinish" />
        </van-popup>
        <van-field required v-model="form.ffixaddr" label="用水地址" placeholder="请输入用水地址" :rules="[{ required: true, message: '请输入用水地址'}]" />
        <van-field readonly clickable v-model="fnetType" label="业务选项" placeholder="请选择业务选项" @click="showFtype = true" :required="true" :rules="[{ required: true, message: '请选择业务选项'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="showFtype" position="bottom">
          <van-picker :default-index="fnetTypeIndex" title="业务选项" show-toolbar :columns="fnetTypeColumns" @cancel="showFtype = false" @confirm="ftypeConfirm" />
        </van-popup>
        <van-field readonly clickable v-model="userType" label="用户类型" placeholder="请选择用户类型" @click="showUtype = true" :required="true" :rules="[{ required: true, message: '请选择用户类型'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="showUtype" position="bottom">
          <van-picker :default-index="userTypeIndex" title="用户类型" show-toolbar :columns="userTypeColumns" @cancel="showUtype = false" @confirm="utypeConfirm" />
        </van-popup>
        <van-field required v-model="form.fnetdaydegree" label="预估月水量" placeholder="请输入预估月水量(单位:立方米)" :rules="[{ required: true, message: '请输入预估月水量(单位:立方米)'}]" />
        <van-field readonly clickable v-model="fcaliber" label="水表口径" placeholder="请选择水表口径" @click="showFcaliber = true" :required="true" :rules="[{ required: true, message: '请选择水表口径'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="showFcaliber" position="bottom">
          <van-picker :default-index="fcaliberIndex" title="水表口径" show-toolbar :columns="fcaliberColumns" @cancel="showFcaliber = false" @confirm="fcaliberConfirm" />
        </van-popup>
      </van-cell-group>
      <van-cell-group title="产权人信息">
        <van-field required v-model="form.fname" label="姓名" @blur="fname" placeholder="请输入姓名" :rules="[{ required: true, message: '请输入姓名'}]" />
        <van-field required v-model="form.faddr" label="通讯地址" placeholder="请输入通讯地址" :rules="[{ required: true, message: '请输入通讯地址'}]" />
        <van-field required v-model="form.fargueno" label="身份证号" placeholder="请输入身份证号" :rules="[{ pattern: $patternId, message: '请输入正确身份证号'}]" />
        <van-field v-model="form.fpho" label="联系电话" placeholder="请输入联系电话" />
        <van-field required v-model="form.fmoveno" label="接收短信号码" placeholder="请输入接收短信号码" @blur="fmoveno" :rules="[{pattern: $pattern, message: '请输入接收短信号码'}]" />
      </van-cell-group>
      <van-cell-group title="证件资料">
        <van-field required name="uploader" label="产权人身份证(上传正反面2张)">
          <template #input>
            <van-uploader multiple :max-count="2" v-model="cardPositiveMst" :after-read="cardPositiveAfter" @delete="cardPositiveDelete" />
          </template>
        </van-field>
        <!-- <van-field required name="uploader" label="产权人身份证(上传正反面2张)">
                    <template #input>
                        <van-uploader 
                            multiple 
                            :max-count="1"
                            v-model="cardAntiMst"
                            :after-read="cardAntiAfter"
                            @delete="cardAntiDelete"/>
                    </template>
                </van-field> -->
        <van-field name="uploader" required label="产权证明">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="propertyOwnerMst" :after-read="propertyOwnerAfter" @delete="propertyOwnerDelete" />
          </template>
        </van-field>
        <van-field name="uploader" label="其他资料">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="otherMst" :after-read="otherAfter" @delete="otherDelete" />
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group title="申请人信息">
        <van-field center clearable label="申请人类别" placeholder="" readonly>
          <template #input>
            <van-radio-group v-model="fnetapplytype" direction="horizontal">
              <van-radio name="1" @click="onChanquanren">产权人
                <!-- <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template> -->
              </van-radio>
              <van-radio name="2" @click="onShenqingren">申请人
                <!-- <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template> -->
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field :required="shenqingren && active == 0" v-model="form.foper" label="姓名" placeholder="请输入姓名" v-if="shenqingren && active == 0" :rules="[{required: true, message: '请输入姓名'}]" />
        <van-field :required="shenqingren && active == 0" v-model="form.foperidno" label="身份证号" placeholder="请输入身份证号" v-if="shenqingren && active == 0" :rules="[{pattern: $patternId, message: '请输入身份证号'}]" />
        <van-field v-model="form.fopertel" label="电话号码" placeholder="请输入电话号码" v-if="shenqingren && active == 0" />
        <van-field required v-model="form.fopermobile" label="手机号码" placeholder="请输入手机号码" :rules="[{pattern: $pattern, message: '请输入手机号码'}]" />
        <van-field v-show="modify" required v-model="form.smscode" center clearable label="短信验证" placeholder="请输入短信验证" :rules="[{required: true, message: '请输入短信验证'}]">
          <template #button>
            <sms-btn :phone="form.fopermobile"></sms-btn>
          </template>
        </van-field>
      </van-cell-group>

      <yonghuxuzhi v-show="modify" @changeChecked="changeChecked" :typecode="typecode" :ftrantype="1"></yonghuxuzhi>

      <van-button v-show="modify" :disabled="!checked" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>

    <van-form @submit="unitOnSubmit" :validate-trigger="$trigger" v-show="active == 1">
      <van-cell-group title="申请信息">
        <van-field v-model="unitForm.fareaid" required is-link readonly label="用水区域" placeholder="请选择所在区域" @click="unitFareaidShow = true" :rules="[{ required: true, message: '请选择所在区域'  }]" />
        <van-popup v-model="unitFareaidShow" round position="bottom">
          <van-cascader v-model="unitCascaderValue" title="请选择所在区域" :options="fareaidOptions" @close="unitFareaidShow = false" @change="onFareaidChange" @finish="unitOnFinish" />
        </van-popup>
        <van-field required v-model="unitForm.ffixaddr" label="用水地址" placeholder="请输入用水地址" :rules="[{ required: true, message: '请输入用水地址'}]" />
        <van-field readonly clickable :default-index="unitFnetTypeIndex" v-model="unfnetType" label="业务选项" placeholder="请选择业务选项" @click="unshowFtype = true" :required="true"
          :rules="[{ required: true, message: '请选择业务选项'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="unshowFtype" position="bottom">
          <van-picker title="业务选项" show-toolbar :columns="fnetTypeColumns" @cancel="unshowFtype = false" @confirm="untypeConfirm" />
        </van-popup>
        <van-field readonly clickable :default-index="unitFnetTypeIndex" v-model="unuserType" label="用户类型" placeholder="请选择用户类型" @click="unshowUtype = true" :required="true"
          :rules="[{ required: true, message: '请选择用户类型'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="unshowUtype" position="bottom">
          <van-picker title="用户类型" show-toolbar :columns="userTypeColumns" @cancel="unshowUtype = false" @confirm="uutypeConfirm" />
        </van-popup>
        <van-field readonly clickable v-model="fcaliber" label="水表口径" placeholder="请选择水表口径" @click="unitshowFcaliber = true" :required="true" :rules="[{ required: true, message: '请选择水表口径'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="unitshowFcaliber" position="bottom">
          <van-picker :default-index="unitfcaliberIndex" title="水表口径" show-toolbar :columns="fcaliberColumns" @cancel="unitshowFcaliber = false" @confirm="unitfcaliberConfirm" />
        </van-popup>
        <van-field required v-model="unitForm.fnetdaydegree" label="预估月水量" placeholder="请输入预估月水量(单位:立方米)" :rules="[{ required: true, message: '请输入预估月水量(单位:立方米)'}]" />
      </van-cell-group>
      <van-cell-group title="产权人信息">
        <van-field required v-model="unitForm.fname" label="单位名称" placeholder="请输入单位名称" :rules="[{ required: true, message: '请输入单位名称' }]" />
        <van-field required v-model="unitForm.faddr" label="通讯地址" placeholder="请输入通讯地址" :rules="[{ required: true, message: '请输入通讯地址' }]" />
        <van-field v-model="unitForm.flegal" label="法人姓名" placeholder="请输入法人姓名" />
        <van-field v-model="unitForm.fpho" label="联系电话" placeholder="请输入联系电话" />
        <van-field required v-model="unitForm.fmoveno" @blur="unitfmoveno" label="接收短信号码" placeholder="请输入接收短信号码" :rules="[{ pattern: $pattern, message: '请输入正确手机号码' }]" />
      </van-cell-group>
      <van-cell-group title="发票信息">
        <van-field readonly clickable v-model="fpayid" label="发票类型" placeholder="请选择发票类型" @click="fpayidShow = true" :required="true" :rules="[{ required: true, message: '请选择发票类型'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="fpayidShow" position="bottom">
          <van-picker title="发票类型" show-toolbar :default-index="unitFpayidIndex" :columns="fpayidColumns" @cancel="fpayidShow = false" @confirm="fpayidConfirm" />
        </van-popup>
        <van-field required v-model="unitForm.ftax" label="社会信用代码" placeholder="请输入社会信用代码" :rules="[{ required: true, message: '请输入社会信用代码' }]" />
        <van-field v-model="unitForm.fbasebank" label="基本银行" placeholder="请输入基本银行" />
        <van-field v-model="unitForm.fbaseaccountno" label="基本账号" placeholder="请输入基本账号" />
        <van-field v-model="unitForm.fzzaddr" label="发票地址" placeholder="请输入发票地址" />
        <van-field v-model="unitForm.fzzpho" label="联系电话" placeholder="请输入联系电话" />
      </van-cell-group>
      <van-cell-group title="证件资料">
        <van-field center clearable label="申请类型" placeholder="" readonly>
          <template #input>
            <van-radio-group v-model="fnetdwsptype" direction="horizontal">
              <van-radio name='1' @click="onYongjiuyongshui">永久用水</van-radio>
              <van-radio name='2' @click="onJijianyongshui">基建用水</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field required name="uploader" label="营业执照（统一社会信用代码）">
          <template #input>
            <van-uploader multiple :max-count="1" v-model="businessLicenseMst" :after-read="businessLicenseAfter" @delete="businessLicenseDelete" />
          </template>
        </van-field>
        <van-field name="uploader" required label="产权证明" v-if="yongjiuyongshui">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="unitpropertyOwnerMst" :after-read="unitpropertyOwnerAfter" @delete="unitpropertyOwnerDelete" />
          </template>
        </van-field>
        <van-field required name="uploader" label="立项批复原件" v-if="jijianyongshui">
          <template #input>
            <van-uploader multiple :max-count="1" v-model="replyMst" :after-read="replyAfter" @delete="replyDelete" />
          </template>
        </van-field>
        <van-field name="uploader" label="其他资料">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="unitotherMst" :after-read="unitotherAfter" @delete="unitotherDelete" />
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group title="申请人信息">
        <van-field required v-model="unitForm.foper" label="姓名" placeholder="请输入姓名" :rules="[{ required: true, message: '请输入姓名' }]" />
        <van-field required v-model="unitForm.foperidno" label="身份证号" placeholder="请输入身份证号" :rules="[{ required: true, message: '请输入身份证号' }]" />
        <van-field v-model="unitForm.fopertel" label="电话号码" placeholder="请输入电话号码" />
        <van-field required v-model="unitForm.fopermobile" label="手机号码" placeholder="请输入手机号码" :rules="[{ required: true, message: '请输入手机号码' }]" />
        <van-field v-show="modify" required v-model="unitForm.smscode" center clearable label="短信验证" placeholder="请输入短信验证" :rules="[{ required: true, message: '请输入短信验证' }]">
          <template #button>
            <sms-btn :phone="unitForm.fopermobile"></sms-btn>
          </template>
        </van-field>
      </van-cell-group>

      <yonghuxuzhi v-show="modify" @changeChecked="unitChangeChecked" :typecode="typecode" :ftrantype="2"></yonghuxuzhi>
      <van-button v-show="modify" :disabled="!unitChecked" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>
  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'

export default {
  components: {
    smsBtn,
  },
  data() {
    return {
      typecode: 201,
      areaList: {},
      fnetTypeColumns: [], // 
      userTypeColumns: [],
      fpayidColumns: [], // 发票类型
      fcaliberColumns: [],
      active: '',
      form: {
        ftrantype: 1,
        fsou: this.$comm.titleShow() ? 2 : 4,
        fareaid: '',
        fareaid1: '',
        fareaid2: '',
        ffixaddr: "",
        fnettype: '',
        fnetusetype: '',
        fnetdaydegree: '',
        fcaliber: 'DN15',
        fname: "",
        faddr: "",
        fargueno: "",
        fpho: "",
        fmoveno: "",
        attach: [],
        fnetapplytype: '1',
        foper: "",
        foperidno: "",
        fopertel: "",
        fopermobile: "",
        smscode: ""
      },
      unitForm: {
        ftrantype: 2,
        fsou: this.$comm.titleShow() ? 2 : 4,
        fareaid: '',
        fareaid1: '',
        fareaid2: '',
        ffixaddr: '',
        fnettype: '',
        fnetusetype: '',
        fnetdaydegree: '',
        fcaliber: 'DN15',
        fname: '',
        faddr: '',
        flegal: '',
        fpho: '',
        fmoveno: '',
        fpayid: '',
        ftax: '',
        fbasebank: '',
        fbaseaccountno: '',
        fzzaddr: '',
        fzzpho: '',
        fnetdwsptype: 1,
        attach: [],
        fnetapplytype: '2',
        foper: '',
        foperidno: '',
        fopertel: '',
        fopermobile: '',
        smscode: ''
      },
      visiable: false,
      chanquanren: true,
      shenqingren: false,
      yongjiuyongshui: true,
      jijianyongshui: false,
      fareaidShow: false,
      cascaderValue: '',
      unitCascaderValue: '',
      fareaidOptions: [],
      fnetType: '', // 业务选项
      showFtype: false, // 显示业务选项
      userType: '', // 用户类型
      showUtype: false, // 显示用户类型
      unfnetType: '', // 单位业务选项
      unshowFtype: false, // 单位显示业务选项
      unuserType: '', // 单位用户类型
      unshowUtype: false, // 单位显示用户类型
      fpayid: '', // 发票类型
      fpayidShow: false, // 发票类型显示
      unitFareaidShow: false,
      activeIcon: 'https://img.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img.yzcdn.cn/vant/user-inactive.png',

      // 个人图片资料
      cardPositive: [], // 身份证正面
      propertyOwner: [], // 产权证明
      other: [], // 个人其他材料
      cardPositiveMst: [], // 身份证
      propertyOwnerMst: [], // 产权证明
      otherMst: [], // 个人其他材料

      // 单位图片资料
      businessLicense: [], // 单位营业执照
      unitpropertyOwner: [], // 单位产权证明
      reply: [], // 单位立项批复
      unitother: [], // 单位其他材料
      businessLicenseMst: [], // 单位营业执照
      unitpropertyOwnerMst: [], // 单位产权证明
      replyMst: [], // 单位立项批复
      unitotherMst: [], // 单位其他材料
      fnetdwsptype: '1',
      fnetapplytype: '1',
      fnetTypeIndex: 0,
      userTypeIndex: 0,
      unitUserTypeIndex: 0,
      unitFnetTypeIndex: 0,
      unitFpayidIndex: 0,
      fcaliber: 'DN15',
      fcaliberIndex: 0,
      unitFCaliberIndex: 0,
      showFcaliber: false,
      unitshowFcaliber: false,
      flag: this.$route.query.busstype ? false : true,
      modify: this.$route.query.modify ? (this.$route.query.modify === '1' || this.$route.query.modify === 1 ? false : true) : true,
      checked: false,
      unitChecked: false
    }
  },
  created() {

  },
  mounted() {
    this.getFareaid()
    this.getUserType()
    this.getFnetType()
    this.getFpayType()
    this.getFcaliber()
    if (!this.flag) {
      this.info()
    }
  },
  methods: {
    fname() {
      // 判断是否是申请人，将姓名产权人带入
      if (this.shenqingren && this.active == 0) {
        this.form.foper = this.form.fname
      }
    },
    fmoveno() {
      this.form.fopermobile = this.form.fmoveno
    },
    unitfmoveno() {
      this.unitForm.fopermobile = this.unitForm.fmoveno
    },
    changeChecked(checked) {
      this.checked = checked
    },
    unitChangeChecked(checked) {
      this.unitChecked = checked
    },
    // 详情
    info() {
      this.$http.post(this.$api.getBussInfo, {
        busstype: this.$route.query.busstype,
        bussno: this.$route.query.bussno
      }).then(res => {
        if (res.code === '000') {
          // 个人
          if (res.data.ftrantype === 1 || res.data.ftrantype === '1') {
            this.active = 0
            this.form = res.data
            this.form.fareaid = res.data.fareaname1 + '/' + res.data.fareaname2
            this.fnetType = res.data.fnettypename
            this.userType = res.data.fnetusetypename
            this.userTypeIndex = this.userTypeColumns.findIndex((profile) => profile.code === res.data.fnetusetype)
            this.fnetTypeIndex = this.fnetTypeColumns.findIndex((profile) => profile.code === res.data.fnettype)
            this.fcaliberIndex = this.fcaliberColumns.findIndex((profile) => profile.code == res.data.fcaliber)
            if (this.fcaliberIndex >= 0) {
              this.fcaliber = this.fcaliberColumns[this.fcaliberIndex].text;
            }

            if (res.data.fnetapplytype == 1) {
              this.fnetapplytype = '1'
              this.onChanquanren()
            } else {
              this.fnetapplytype = '2'
              this.onShenqingren()
            }
            let result = this.$comm.serviceAttach(res.data)
            // 个人图片资料
            this.cardPositive = result.cardPositive
            this.propertyOwner = result.propertyOwner
            this.other = result.other
            this.cardPositiveMst = result.cardPositiveMst
            this.propertyOwnerMst = result.propertyOwnerMst
            this.otherMst = result.otherMst
          } else {
            // 单位
            this.active = 1
            this.unitForm = res.data
            this.unitForm.fareaid = res.data.fareaname1 + '/' + res.data.fareaname2
            this.unfnetType = res.data.fnettypename
            this.unuserType = res.data.fnetusetypename
            this.fpayid = res.data.fpayname
            this.unitUserTypeIndex = this.userTypeColumns.findIndex((profile) => profile.code === res.data.fnetusetype)
            this.unitFnetTypeIndex = this.fnetTypeColumns.findIndex((profile) => profile.code === res.data.fnettype)
            this.unitFpayidIndex = this.fpayidColumns.findIndex((profile) => profile.code === res.data.fpayid)
            this.unitFCaliberIndex = this.fcaliberColumns.findIndex((profile) => profile.code == res.data.fcaliber)
            if (this.unitFCaliberIndex >= 0) {
              this.fcaliber = this.fcaliberColumns[this.unitFCaliberIndex].text;
            }
            // this.fcaliber = this.fcaliberColumns[this.unitFCaliberIndex].text;
            if (res.data.fnetdwsptype == 1) {
              this.fnetdwsptype = '1'
              this.onYongjiuyongshui()
            } else {
              this.fnetdwsptype = '2'
              this.onJijianyongshui()
            }
            // 单位图片资料
            let result = this.$comm.serviceAttach(res.data)
            this.businessLicense = result.businessLicense
            this.unitpropertyOwner = result.unitpropertyOwner
            this.reply = result.reply
            this.unitother = result.unitother
            this.businessLicenseMst = result.businessLicenseMst
            this.unitpropertyOwnerMst = result.unitpropertyOwnerMst
            this.replyMst = result.replyMst
            this.unitotherMst = result.unitotherMst

          }
          this.$clear()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 用户类型
    getUserType() {
      this.userTypeColumns = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 5,
        "parentid": 1
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.userTypeColumns.push({
              text: el.fname,
              code: el.fid
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 个人选择用户类型
    utypeConfirm(obj, index) {
      this.userType = obj.text
      this.form.fnetusetype = this.userTypeColumns[index].code
      console.log(this.form.fnetusetype)
      this.showUtype = false
    },
    // 业务选项
    getFnetType() {
      this.fnetTypeColumns = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 4,
        "parentid": 0
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.fnetTypeColumns.push({
              text: el.fname,
              code: el.fid
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 个人选择业务选择
    ftypeConfirm(obj, index) {
      this.fnetType = obj.text
      this.form.fnettype = this.fnetTypeColumns[index].code
      console.log(this.form.fnettype)
      this.showFtype = false
    },
    // 水表口径
    getFcaliber() {
      this.fcaliberColumns = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 13,
        "parentid": 0
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.fcaliberColumns.push({
              text: el.fname,
              code: el.fid
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 选择水表口径
    fcaliberConfirm(obj, index) {
      this.fcaliber = obj.text
      this.form.fcaliber = this.fcaliberColumns[index].code
      this.showFcaliber = false
    },
    // 选择水表口径
    unitfcaliberConfirm(obj, index) {
      this.fcaliber = obj.text
      this.unitForm.fcaliber = this.fcaliberColumns[index].code
      this.unitshowFcaliber = false
    },
    // 区域
    getFareaid() {
      this.fareaidOptions = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 1,
        "parentid": 0
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.fareaidOptions.push({
              text: el.fname,
              value: el.fid,
              children: []
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 监听选择区域
    onFareaidChange({ value }) {
      for (let i = 0; i < this.fareaidOptions.length; i++) {
        if (value == this.fareaidOptions[i].value) {
          this.fareaidOptions[i].children = []
          this.$http.post(this.$api.getBasedata, {
            "typeid": 3,
            "parentid": value
          }).then(res => {
            if (res.code === '000') {
              res.data.forEach(el => {
                this.fareaidOptions[i].children.push({
                  text: el.fname,
                  value: el.fid
                })
              })
            } else {
              this.$toast(res.msg)
            }
          })
          break
        }
      }
    },
    // 个人选择区域
    onFinish({ selectedOptions }) {
      this.fareaidShow = false
      this.form.fareaid1 = selectedOptions[0].value
      if (selectedOptions.length > 1) {
        this.form.fareaid2 = selectedOptions[1].value
      }
      this.form.fareaid = selectedOptions.map((option) => option.text).join('/');
    },
    // 身份证
    cardPositiveAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.cardPositive.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    cardPositiveDelete(file, detail) {
      this.cardPositive.splice(detail.index, 1)
    },
    // 产权证明
    propertyOwnerAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.propertyOwner.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    propertyOwnerDelete(file, detail) {
      this.propertyOwner.splice(detail.index, 1)
    },
    // 其他证明
    otherAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.other.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    otherDelete(file, detail) {
      this.other.splice(detail.index, 1)
    },
    onGetValue(key2, value) {
      this.form[key2] = value
    },
    // 产权人
    onChanquanren() {
      this.form.fnetapplytype = 1
      this.chanquanren = true
      this.shenqingren = false
    },
    // 申请人
    onShenqingren() {
      this.form.foper = this.form.fname
      this.form.foper = this.form.fname
      this.form.fnetapplytype = 2
      this.chanquanren = false
      this.shenqingren = true
    },
    onYongjiuyongshui() {
      this.unitForm.fnetdwsptype = 1
      this.yongjiuyongshui = true
      this.jijianyongshui = false
    },
    onJijianyongshui() {
      this.unitForm.fnetdwsptype = 2
      this.yongjiuyongshui = false
      this.jijianyongshui = true
    },
    // 个人提交
    onUserSubmit() {
      this.form.attach = []
      if (this.cardPositive.length <= 0 || this.cardPositive.length < 2) {
        this.$toast('产权人身份证正反面不能为空')
        return
      }
      this.form.attach.push({
        typeid: 1,
        url: this.cardPositive[0].url + ',' + this.cardPositive[1].url
      })
      if (this.propertyOwner.length <= 0) {
        this.$toast('产权证明不能为空')
        return
      } else {
        let url = ''
        this.propertyOwner.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.form.attach.push({
          typeid: 2,
          url: url
        })
      }
      if (this.other.length > 0) {
        let url = ''
        this.other.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.form.attach.push({
          typeid: 13,
          url: url
        })
      }
      this.$http.post(this.$api.saveApply, this.form).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 单位选择区域
    unitOnFinish({ selectedOptions }) {
      this.unitFareaidShow = false
      this.unitForm.fareaid1 = selectedOptions[0].value
      if (selectedOptions.length > 1) {
        this.unitForm.fareaid2 = selectedOptions[1].value
      }
      this.unitForm.fareaid = selectedOptions.map((option) => option.text).join('/');
    },
    // 单位选择用户类型
    uutypeConfirm(obj, index) {
      this.unuserType = obj.text
      this.unitForm.fnetusetype = this.userTypeColumns[index].code
      console.log(this.unitForm.fnetusetype)
      this.unshowUtype = false
    },
    // 单位选择业务选择
    untypeConfirm(obj, index) {
      this.unfnetType = obj.text
      this.unitForm.fnettype = this.fnetTypeColumns[index].code
      console.log(this.form.fnettype)
      this.unshowFtype = false
    },
    // 发票类型
    getFpayType() {
      this.fpayidColumns = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 8,
        "parentid": 0
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.fpayidColumns.push({
              text: el.fname,
              code: el.fid
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 发票类型选择
    fpayidConfirm(obj, index) {
      this.fpayid = obj.text
      this.unitForm.fpayid = this.fpayidColumns[index].code
      console.log(this.unitForm.fpayid)
      this.fpayidShow = false
    },
    // 营业执照
    businessLicenseAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.businessLicense.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    businessLicenseDelete(file, detail) {
      this.businessLicense.splice(detail.index, 1)
    },
    // 单位产权证明
    unitpropertyOwnerAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.unitpropertyOwner.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    unitpropertyOwnerDelete(file, detail) {
      this.unitpropertyOwner.splice(detail.index, 1)
    },
    // 立项批复原件
    replyAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.reply.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    replyDelete(file, detail) {
      this.reply.splice(detail.index, 1)
    },
    // 单位其他证明
    unitotherAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.unitother.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    unitotherDelete(file, detail) {
      this.unitother.splice(detail.index, 1)
    },
    // 单位提交
    unitOnSubmit() {
      this.unitForm.attach = []
      if (this.businessLicense.length <= 0) {
        this.$toast('营业执照不能为空')
        return
      }
      this.unitForm.attach.push({
        typeid: 3,
        url: this.businessLicense[0].url
      })
      if (this.unitpropertyOwner.length <= 0) {// 单位产权证明
        this.$toast('产权证明不能为空')
        return
      } else {
        let url = ''
        this.unitpropertyOwner.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.unitForm.attach.push({
          typeid: 2,
          url: url
        })
      }
      if (this.reply.length > 0) { // 单位立项批复
        let url = ''
        this.reply.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.unitForm.attach.push({
          typeid: 4,
          url: url
        })
      }
      if (this.unitother.length > 0) { // 单位其他材料
        let url = ''
        this.unitother.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.unitForm.attach.push({
          typeid: 13,
          url: url
        })
      }
      console.log(this.unitForm)
      this.$http.post(this.$api.saveApply, this.unitForm).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onYonghuxuzhi() {
      this.visiable = true
    },
  },
}
</script>

<style lang="less" scoped>
.scan-bind {
  height: 100%;
  background: rgb(248, 248, 248);

  .content {
    padding: 10px 0;
    /*text-align: center;*/

    /*.txt1 {*/
    /*    margin-top: 20px;*/
    /*    font-size: 16px;*/
    /*}*/

    /*.txt2 {*/
    /*    margin-top: 20px;*/
    /*    color: red;*/
    /*    font-size: 14px;*/
    /*}*/

    /*.btn {*/
    /*    margin-top: 20px;*/
    /*    width: 100%;*/
    /*}*/
  }
}
</style>
